<template>
  <div class="exchange">
    <div class="header acea-row row-around">
      <div class="item">
        <p class="money">{{ userInfo.lsjf }}</p>
        <p class="text">可用创富积分</p>
      </div>
      <!-- <div class="item">
        <p class="money">{{ userInfo.now_money }}</p>
        <p class="text">可用余额</p>
      </div> -->
    </div>
    <!-- <div class="nav acea-row row-around">
      <div
        class="item"
        :class="{ on: type == 'brokerage_price' }"
        @click="changeNav('brokerage_price')"
      >
        佣金
      </div>
      <div
        class="item"
        :class="{ on: type == 'now_money' }"
        @click="changeNav('now_money')"
      >
        余额
      </div>
    </div> -->
    <div class="infos">
      <div class="acea-row row-center-wrapper">
        <span>接收人账号:</span>
        <input type="text" v-model="name" placeholder="请输入接收人的账号" />
      </div>
      <div class="acea-row row-center-wrapper">
        <span>接收人姓名:</span>
        <input
          type="text"
          v-model="nickname"
          placeholder="请输入接收人的姓名"
        />
      </div>
      <div class="acea-row row-center-wrapper">
        <span>交易密码:</span>
        <input
          type="password"
          v-model="password"
          placeholder="请输入交易密码"
        />
      </div>
      <!-- <div class="item acea-row">
        <span>验证码:</span>
        <input
          type="text"
          placeholder="填写验证码"
          class="codeIput"
          v-model="captcha"
        />
        <button
          class="code font-color-red"
          :disabled="disabled"
          :class="disabled === true ? 'on' : ''"
          @click="code"
        >
          {{ text }}
        </button>
      </div> -->
      <div class="acea-row row-center-wrapper">
        <span v-if="type == 'now_money'">余额转出:</span>
        <span v-else>创富积分转出:</span>
        <input
          type="text"
          v-model="money"
          :placeholder="
            type == 'now_money'
              ? '请输入要转出的创富积分'
              : '请输入要转出的创富积分'
          "
          @input="inputmoney"
        />
      </div>
    </div>
    <div class="exchange_btn" @click="submit">确认转账</div>
    <div
      class="exchange_btn"
      @click="$router.push('/user/record?type=lsjf')"
      v-if="type == 'now_money'"
    >
      转账记录
    </div>
    <div
      class="exchange_btn"
      @click="$router.push('/user/record?type=lsjf')"
      v-else
    >
      转账记录
    </div>
  </div>
</template>
<script>
// import { mapGetters } from "vuex";
import {
  transFerut,
  getCodeApi,
  registerVerify,
  getUser
} from "../../api/user";
import Vue from "vue";
import { Toast } from "vant";
import { sub } from "@utils/bc";
import sendVerifyCode from "@mixins/SendVerifyCode";
import { required, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import { setTimeout } from "timers";
import { VUE_APP_API_URL } from "@utils";
Vue.use(Toast);
export default {
  name: "exchange",
  data: function() {
    return {
      userInfo: {},
      type: "brokerage_price",
      captcha: "",
      name: "",
      money: "",
      mark: "",
      password: "",
      pw: "",
      keyCode: "",
      codeUrl: "",
      showpw: false
    };
  },
  mixins: [sendVerifyCode],
  // computed: mapGetters(["userInfo"]),
  mounted: function() {
    this.getCode();
    this.user();
  },
  methods: {
    user() {
      getUser()
        .then(res => {
          this.userInfo = res.data;
        })
        .catch(res => {
          console.log(res);
        });
    },
    changeNav(type) {
      this.type = type;
    },
    async code() {
      let that = this;
      const { phone } = that.userInfo;
      try {
        await that
          .$validator({
            phone: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ phone });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      registerVerify({ phone: phone, key: that.keyCode, code: that.codeVal })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(res => {
          if (res.data.status === 402) {
            that.codeUrl = `${VUE_APP_API_URL}/sms_captcha?key=${that.keyCode}`;
            that.isShowCode = true;
          }
          that.$dialog.error(res.msg);
        });
    },
    again() {
      this.codeUrl =
        VUE_APP_API_URL + "/captcha?" + this.keyCode + Date.parse(new Date());
    },
    getCode() {
      getCodeApi()
        .then(res => {
          this.keyCode = res.data.key;
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    },
    submit() {
      let { money, name, password, nickname } = this;
      let newmoney = this.userInfo.now_money;
      let brokerage_price = this.userInfo.brokerage_price;
      if (!name) {
        this.$dialog.toast({ mes: "接收人的账号不能为空" });
        return false;
      }
      if (!nickname) {
        this.$dialog.toast({ mes: "接收人的姓名不能为空" });
        return false;
      }
      if (!password) {
        this.$dialog.toast({ mes: "交易密码不能为空" });
        return false;
      }
      if (!money) {
        this.$dialog.toast({ mes: "输入的金额不能为空" });
        return false;
      }

      let data = {
        num: money,
        type: "lsjf",
        pwd_pay: password,
        nickname: nickname,
        zr_account: name
      };
      transFerut(data)
        .then(res => {
          if (res.status == 200) {
            this.$dialog.toast({ mes: res.msg });
            if (this.type == "now_money") {
              this.userInfo.now_money = sub(newmoney, money);
            }
            if (this.type == "brokerage_price") {
              this.userInfo.brokerage_price = sub(brokerage_price, money);
            }
            this.user();
            this.$store.dispatch("USERINFO", true);
            setTimeout(() => {
              this.$router.go(-1);
            }, 1500);
          }
        })
        .catch(err => {
          this.$dialog.toast({ mes: err.msg });
          console.log(err);
        });
    },
    inputmoney() {
      if (
        parseInt(this.money) > parseInt(this.userInfo.now_money) &&
        this.type == "now_money"
      ) {
        this.$dialog.toast({ mes: "输入的余额不能超过当前余额" });
        this.money = this.userInfo.now_money;
      }
      if (
        parseInt(this.money) > parseInt(this.userInfo.brokerage_price) &&
        this.type == " brokerage_price"
      ) {
        this.$dialog.toast({ mes: "输入的佣金不能超过当前佣金" });
        this.money = this.userInfo.brokerage_price;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.exchange {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: rgb(246, 246, 246);
  .header {
    width: 100%;
    background: #0e98fd;
    padding: 8vw 4vw 4vw;
    .money {
      color: #ffffff;
      font-weight: 600;
      font-size: 8vw;
    }
    .text {
      color: #ffffff;
      font-size: 3.5vw;
    }
  }
  .nav {
    height: 12vw;
    background: #ffffff;
    .item {
      line-height: 12vw;
      &.on {
        color: #0e98fd;
        position: relative;
        &::after {
          content: "";
          left: 0;
          right: 0;
          margin: 0 auto;
          position: absolute;
          width: 6vw;
          border-bottom: 2px solid #0e98fd;
          bottom: 2vw;
        }
      }
    }
  }
  .infos {
    width: 92vw;
    margin: 4vw;
    background-color: #ffffff;
    border-radius: 2vw;
    > div {
      height: 12vw;
      align-items: center;
      flex-wrap: nowrap;
      .codeIput {
        width: 40vw;
      }
      span {
        width: 30%;
        text-align: right;
        padding-right: 2vw;
      }
      input {
        width: 70%;
      }
    }
  }
  .mark {
    width: 92vw;
    margin: 4vw;
    height: 20vw;
    padding: 2vw;
    background-color: #ffffff;
    border-radius: 2vw;
    textarea {
      width: 100%;
      height: 100%;
    }
  }
  .exchange_btn {
    width: 92vw;
    margin: 4vw;
    text-align: center;
    height: 12vw;
    line-height: 12vw;
    color: #ffffff;
    background: #0e98fd;
    border-radius: 2vw;
  }
}
</style>
